/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportListConnectionsByStationQueryResponse, SocialExportListConnectionsByStationPathParams, SocialExportListConnectionsByStation400, SocialExportListConnectionsByStation401, SocialExportListConnectionsByStation403, SocialExportListConnectionsByStation404 } from "../models/SocialExportListConnectionsByStation";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportListConnectionsByStation } from "../axios/socialExportListConnectionsByStation";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportListConnectionsByStationQueryKey = (station: SocialExportListConnectionsByStationPathParams["station"]) => ["api-v2", { url: '/social-export/v1/connections/by-station/:station', params: {station:station} }] as const

export type SocialExportListConnectionsByStationQueryKey = ReturnType<typeof socialExportListConnectionsByStationQueryKey>

export function socialExportListConnectionsByStationQueryOptions(station: SocialExportListConnectionsByStationPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportListConnectionsByStationQueryKey(station)
        return queryOptions<SocialExportListConnectionsByStationQueryResponse, ResponseErrorConfig<SocialExportListConnectionsByStation400 | SocialExportListConnectionsByStation401 | SocialExportListConnectionsByStation403 | SocialExportListConnectionsByStation404>, SocialExportListConnectionsByStationQueryResponse, typeof queryKey>({
         enabled: !!(station),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportListConnectionsByStation(station, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns connections linked to the given station, including global lastUsedAt, lastUsedForStationAt, and platform media limits for this station.
 * @summary List connection states assigned to a station
 * {@link /social-export/v1/connections/by-station/:station}
 */
export function useSocialExportListConnectionsByStation<TData = SocialExportListConnectionsByStationQueryResponse, TQueryData = SocialExportListConnectionsByStationQueryResponse, TQueryKey extends QueryKey = SocialExportListConnectionsByStationQueryKey>(station: SocialExportListConnectionsByStationPathParams["station"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportListConnectionsByStationQueryResponse, ResponseErrorConfig<SocialExportListConnectionsByStation400 | SocialExportListConnectionsByStation401 | SocialExportListConnectionsByStation403 | SocialExportListConnectionsByStation404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportListConnectionsByStationQueryKey(station)
         

         const query = useQuery({
          ...socialExportListConnectionsByStationQueryOptions(station, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportListConnectionsByStation400 | SocialExportListConnectionsByStation401 | SocialExportListConnectionsByStation403 | SocialExportListConnectionsByStation404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}